import React from 'react';

import styled from 'styled-components';

import CompaniesActions from './CompaniesActions';
import CompaniesFilters from './filters/CompaniesFilters';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const CompaniesControls = () => {
  return (
    <Container>
      <CompaniesFilters />
      <CompaniesActions />
    </Container>
  );
};

export default CompaniesControls;
